export default __webpack_public_path__ + "static/media/logo.8bf201c2.png";